export const userData = {
  id: 1,
  nombre: 'Camilo Bohorquez',
  email: 'camilo.b.q@hotmail.com',
  photo: 'perfil.png',
  description:
    'Hola, soy Camilo Bohorquez, ha sido el texto de relleno estándar de la industria desde el año 1500, cuando un impresor desconocido tomó una galera de tipos.'
};
